import {DateHelper} from "./dateHelper";

export const dateFormatedForAPI = (date: Date): string => {
    if (!DateHelper.isDateDefinedAndValid(date)) {
        return '';
    }
    const year = date.getFullYear().toString().padStart(4, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}